'use strict';

var styled = require('styled-components');
var styles = require('../Button/styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const TextOverflowPropsStyle = styled.css `
  text-overflow: ${({ textOverflow }) => (textOverflow ? 'ellipsis' : undefined)};
  overflow-x: ${({ textOverflow }) => (textOverflow ? 'hidden' : undefined)};
  display: ${({ textOverflow }) => (textOverflow ? 'inline-block' : undefined)};
  white-space: ${({ textOverflow }) => (textOverflow ? 'nowrap' : undefined)};
`;
const Anchor = styled__default.default.a `
  cursor: pointer;
  color: ${({ theme }) => theme.designTokens.anchorTextColor};
  text-decoration: ${({ theme }) => theme.designTokens.anchorTextDecoration};
  ${TextOverflowPropsStyle}
  &,
  &:hover,
  &:focus {
    border: none;
    font: inherit;
    line-height: inherit;
    background: inherit;
    outline: none;
  }
  &:hover {
    text-decoration: ${({ theme }) => theme.designTokens.anchorHoverTextDecoration};
  }
  &:focus {
    text-decoration: ${({ theme }) => theme.designTokens.anchorFocusTextDecoration};
    color: ${({ theme }) => theme.designTokens.anchorFocusTextColor};
  }
  /* stylelint-disable */
  ${styles.Styled.Button} &,
  ${styles.Styled.Button} &:hover,
  ${styles.Styled.Button} &:focus {
    color: inherit;
    text-decoration: none;
    font: inherit;
  }
  /* stylelint-enable */
`;
const Styled = {
    Anchor,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
